const getters = {
	userInfo: state => state.user.userInfo,
	systeminfo: state => state.app.systeminfo,
	
	activeIndex: state => state.app.sidebar.activeIndex,
	file_info:state => state.file.file_info,
	// 权限
	allAuth: state => state.user.allAuth,
  
	// 路由
	addRouters: state => state.permission.addRouters,
	settingRouters: state => state.permission.settingRouters,
	customerRouters: state => state.permission.customerRouters,
	financeRouters: state => state.permission.financeRouters,
	lawcaseRouters: state => state.permission.lawcaseRouters,
	contractRouters: state => state.permission.contractRouters,
	indexRouters: state => state.permission.indexRouters,
	eventRouters: state => state.permission.eventRouters,
	
	// 详情的角标
	customerBadgeNum: state => state.customer.badgeNum,
	lawcaseBadgeNum: state => state.lawcase.badgeNum,
	contractBadgeNum: state => state.contract.badgeNum,
	
	// 消息
	messageNum: state => state.customer.messageNum,
}
/**
 * 使用说明
 * import { mapGetters } from 'vuex'
 * computed: {
    ...mapGetters([
      'userInfo'
    ])
  }
 */

export default getters
